<div class="table-responsive">
  <table class="table align-middle mb-0">
    <thead class="text-muted">
      <tr>
        <th [ngClass]="!column?.btn_type ? 'text-start' : 'text-end'" *ngFor="let column of columns; let i = index">
          {{ column.label }}
        </th>
        @if (actions.length) {
          <th *ngIf="onView || onDelete || onDownload" class="text-center">Actions</th>
        }
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let row of data">
        <td [ngClass]="!column?.btn_type ? 'text-start' : 'text-end'" *ngFor="let column of columns; let i = index">
          @if (column.label === 'Stock Status') {
            @if (!getBooleanValue(row, column.field)) {
              <span class="app-badge badge-success">In Stock</span>
            } @else {
              <span class="app-badge badge-danger">Low Stock</span>
            }
          } @else if (!column.btn_type) {
            {{
              column.format?.(getValue(row, column.field?.toString() ?? ''), row) ??
                getValue(row, column.field?.toString() ?? '')
            }}
          } @else if (column.btn_type === 'Add Entry') {
            <button class="btn btn-soft-primary gap-1" (click)="onClickAddEntry.emit(row)">
              <i class="bi bi-plus-circle"></i>
              @if (row['entries'] && row['entries'].length > 0) {
                <span>Update Entry</span>
              } @else {
                <span>Add Entry</span>
              }
            </button>
          } @else if (column.btn_type === 'consumption') {
            <button class="btn btn-soft-primary d-flex align-items-center gap-1" (click)="onClickAddEntry.emit(row)">
              <i class="bi bi-flask"></i>
              <span class="d-none d-md-inline">Consumptions</span>
            </button>
          } @else if (column.btn_type === 'adjust') {
            <button class="btn btn-soft-primary d-flex align-items-center gap-1" (click)="onClickAdjust.emit(row)">
              <i class="bi bi-sliders"></i>
              <span>Adjust</span>
            </button>
          } @else if (column.btn_type === 'salary') {
            <button class="btn btn-soft-primary d-flex align-items-center gap-1" (click)="onClickSalarySheet.emit(row)">
              <i class="bi bi-download"></i>
              <span>Salary Sheet</span>
            </button>
          }
        </td>

        <td *ngIf="actions.length" class="text-center" (click)="$event.stopPropagation()">
          <div class="d-flex flex-row gap-2 justify-content-center">
            <button
              *ngIf="actions.includes(Action.VIEW)"
              class="btn btn-action-info"
              (click)="emit(Action.VIEW, row)"
              title="View">
              <i class="bi bi-eye"></i>
            </button>
            <button
              *ngIf="actions.includes(Action.EDIT)"
              class="btn btn-action-edit"
              (click)="emit(Action.EDIT, row)"
              title="Edit">
              <i class="bi bi-pencil"></i>
            </button>
            <button
              *ngIf="actions.includes(Action.DOWNLOAD)"
              class="btn btn-action-download"
              (click)="emit(Action.DOWNLOAD, row)"
              title="Download">
              <i class="bi bi-download"></i>
            </button>
            <button
              *ngIf="actions.includes(Action.DELETE)"
              class="btn btn-action-delete"
              (click)="emit(Action.DELETE, row)"
              title="Delete">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
